import {useEffect} from 'react';
import {useQuery} from '@tanstack/react-query';
import {getHomeInfo} from '@/services/home';
import {queryClient} from '@/utils/queryClient';

export const homeKeys = {
    all: ['home'] as const,
    info: () => [...homeKeys.all, 'info'] as const,
};

/**
 * 应用启动时并行预取首页信息
 */
export const usePrefetchHomeInfo = () => {
    useEffect(() => {
        void queryClient.prefetchQuery({
            queryKey: homeKeys.info(),
            queryFn: getHomeInfo,
        });
    }, []);
};

export const useHomeInfo = () => {
    const query = useQuery({
        queryKey: homeKeys.info(),
        queryFn: getHomeInfo,
    });

    return {
        ...query,
        /** 我的项目 */
        myProjects: query.data?.myProjects,
        /** 爆款案例 */
        hitCases: query.data?.hitCases,
        /** 创作入口配置 */
        conf: query.data?.entryConf,
        /** 资产页 Tab 配置 */
        assetConf: query.data?.assetConf,
        /** 反馈二维码 */
        qrCode: query.data?.qrCode,
        /** 举报与反馈邮箱 */
        email: query.data?.email,
        /** 官方企微二维码 */
        contactQrCode: query.data?.contactQrCode,
    };
};
